// src/redux/principles/principleSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = 'https://aadhavacademy.com/api/study/principle.php'; // Replace with actual principles API if different

// Fetch all principles
export const fetchPrinciples = createAsyncThunk('principles/fetchPrinciples', async (params) => {
  try {
    const { search, page, limit } = params;
    const response = await axios.get(API_URL, {
      params: { search, page, limit }
    });
    console.log(response.data);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
});

// Add a new principle
export const addPrinciple = createAsyncThunk('principles/addPrinciple', async (principleData) => {
  try {
    const response = await axios.post(API_URL, principleData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
});

// Update an existing principle
export const updatePrinciple = createAsyncThunk('principles/updatePrinciple', async ({ id, principleData }) => {
  try {
    const response = await axios.put(`${API_URL}?id=${id}`, principleData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
});

// Delete a principle
export const deletePrinciple = createAsyncThunk('principles/deletePrinciple', async (id) => {
  try {
    const response = await axios.delete(`${API_URL}?id=${id}`);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
});

// Slice definition
const principleSlice = createSlice({
  name: 'principles',
  initialState: {
    principles: [],
    total: 0,
    totalPages: 0,
    currentPage: 1,
    loading: false,
    error: null,
    selectedPrinciple: null, // For editing/viewing a principle
  },
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setSelectedPrinciple: (state, action) => {
      state.selectedPrinciple = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPrinciples.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPrinciples.fulfilled, (state, action) => {
        state.principles = action.payload.principles || [];
        state.total = action.payload.total || 0;
        state.totalPages = action.payload.totalPages || 0;
        state.currentPage = action.payload.currentPage || 1;
        state.loading = false;
      })
      .addCase(fetchPrinciples.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      })
      .addCase(addPrinciple.fulfilled, (state, action) => {
        state.principles.push(action.payload);
      })
      .addCase(updatePrinciple.fulfilled, (state, action) => {
        const updated = action.payload;
        state.principles = state.principles.map((principle) =>
          principle.id === updated.id ? updated : principle
        );
      })
      .addCase(deletePrinciple.fulfilled, (state, action) => {
        state.principles = state.principles.filter(
          (principle) => principle.id !== action.payload.id
        );
      });
  }
});

export const { setCurrentPage, setSelectedPrinciple } = principleSlice.actions;
export default principleSlice.reducer;
